import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import { Text } from 'components/Text';

// Layout
import Layout from 'layouts/javascript';

// Sections
import Form from './sections/Form';
import Success from './sections/Success';

import './styles.scss';

function Dashboard({ success }) {
  const date = moment.tz('2025-05-15T00:00:00', 'America/New_York');

  const [dateDiff, setDiff] = useState([]);

  useEffect(() => {
    updateDate();
    const timerID = setInterval(() => updateDate(), 1000);
    return () => clearInterval(timerID);
  }, []);

  const updateDate = () => {
    const today = moment();

    const diffInDays = date.diff(today, 'days');
    const diffInHours = date.diff(today, 'hours');
    const diffInMinutes = date.diff(today, 'minutes');
    const diffInSeconds = date.diff(today, 'seconds');

    const numhours = Math.floor(diffInHours - (24 * diffInDays));
    const numminutes = Math.floor((diffInMinutes - (diffInDays * 24 * 60) - (numhours * 60)));

    const seconds = Math.floor((diffInSeconds % 86400) % 60);

    if (diffInDays <= 0 && numhours <= 0 && numminutes <= 0 && seconds <= 0) {
      const uDateDiff = [
        { lable: 'days', diff: 0 },
        { lable: 'hours', diff: 0 },
        { lable: 'mins', diff: 0 },
        { lable: 'sec', diff: 0 },
      ];

      setDiff([...uDateDiff]);
    } else {
      const uDateDiff = [
        { lable: 'days', diff: diffInDays },
        { lable: 'hours', diff: numhours },
        { lable: 'mins', diff: numminutes },
        { lable: 'sec', diff: seconds },
      ];
      setDiff([...uDateDiff]);
    }
  };

  return (
    <Layout>
      <div className="content">
        <div className="content__main">
          {success ? (
            <>
              <h1>You’re all set!</h1>
              <Success />
            </>
          ) : (
            <>
              <h1>Become a Highly Paid Blockchain Developer</h1>
              <Form dateDiff={dateDiff} />
            </>
          )}
        </div>
        <div className="content__footer">
          <Text {...{ type: 'text_14', className: 'footer-text' }}>
            © Dapp University&nbsp;
            {new Date().getFullYear()}
            . All rights reserved.
          </Text>
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
